import { HttpClient } from '@angular/common/http';
import { Injectable } from "@angular/core";
import { AppInitService } from 'src/app/app-init.service';
import { AppConfigurations } from 'src/app/shared/models/appConfiguration.model';

declare const window: any;

@Injectable({
    providedIn: 'root'
})
export class BCNotificationService {
    private baseUrl: string = '';
    private notificationController: string = '';
    private appConfig!: AppConfigurations;

    constructor(private appInitService: AppInitService, private http: HttpClient) {
        appInitService.getAppConfiguration$().subscribe({
            next: (config) => this._onRecieveConfig(config)
        })
    }

    private _onRecieveConfig(appConfig: AppConfigurations) {
        this.appConfig = appConfig;
        this.baseUrl = this.appConfig.notificationApi.baseApiUrl;
        this.notificationController = this.appConfig.notificationApi.notificationController;
    }

    readAlert(alertId: number) {
        const url = `${this.baseUrl}${this.notificationController}${alertId}/updatestatus/read`;
        return this.http.patch(url, null);
    }

}
